import { SET_FIND_STORE_SLIDER_PROPS } from '../actionTypes/FindStoresActionTypes';

function FindStoreSliderPropsReducer(state = {}, action) {
    const { payload } = action;
    switch (action.type) {
        case SET_FIND_STORE_SLIDER_PROPS:
            return {
                ...payload,
            };
        default:
            return state;
    }
}

FindStoreSliderPropsReducer.reducerName = 'findStoreSliderProps';
export default FindStoreSliderPropsReducer;
